import facepaint from "facepaint";

export default facepaint([
  "@media (min-width: 540px)",
  "@media (min-width: 720px)",
  "@media (min-width: 960px)",
  "@media (min-width: 1140px)"
]);
